import cloudflareService from '@/common/services/cloudflareService';
import { SevenApiRoutes } from '@/modules/seven';
import axiosInstance from '../userFundsAxiosInstance';
import type { UserFundsBalanceResponse } from '../userFundsTypes';

const getUserFunds = () => {
  const BALANCE_URL = cloudflareService.generateCloudflareUrl(`${SevenApiRoutes.routes.mainUrl}/api/terminal/funds.json`);

  return axiosInstance.get<UserFundsBalanceResponse>(BALANCE_URL);
};

export {
  getUserFunds,
};
